import React from 'react';

const PackingTable = ({ items }) => {
  const totals = items.reduce((acc, item) => {
    acc.quantity += item.quantity || 0;
    acc.eaWeight += parseFloat(item.eaWeight) || 0;
    acc.eaSumWeight += parseFloat(item.eaSumWeight) || 0;
    acc.netWeight += item.netWeight || 0;
    acc.grossWeight += item.grossWeight || 0;
    return acc;
  }, { quantity: 0, eaWeight: 0, eaSumWeight: 0, netWeight: 0, grossWeight: 0 });

  return (
    <table className="packing-table">
      <thead>
        <tr className="nested-header">
          <th rowSpan="2">Item</th>
          <th rowSpan="2">DESCRIPTIONS OF GOODS</th>
          <th>QTY</th>
          <th>EA</th>
          <th>EA sum</th>
          <th>Net</th>
          <th>Gross</th>
          <th>Cartons</th>
          <th rowSpan="2">W×D×H(cm)</th>
          <th rowSpan="2">CBM(m3)</th>
        </tr>
        <tr className="nested-header">
          <th>PCS</th>
          <th>Weight</th>
          <th>Weight</th>
          <th>Weight</th>
          <th>Weight</th>
          <th>No.</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <tr key={index}>
            <td className="item-col">{item.item}</td>
            <td className="item-col">{item.description}</td>
            <td>{item.quantity}</td>
            <td>{item.eaWeight}</td>
            <td>{item.eaSumWeight}</td>
            <td>{item.netWeight ? item.netWeight.toFixed(1) : '0.0'}</td>
            <td>{item.grossWeight ? item.grossWeight.toFixed(1) : '0.0'}</td>
            <td>{item.cartonNo}</td>
            <td>{item.dimensions.width && item.dimensions.width > 0 
                  ? `${item.dimensions.width}*${item.dimensions.depth}*${item.dimensions.height}` 
                  : ''}</td>
            <td>{item.cbm > 0 ? item.cbm : ''}</td>
          </tr>
        ))}
        <tr className="total-row">
          <td colSpan="2">TOTAL</td>
          <td>{totals.quantity}</td>
          <td></td>
          <td></td>
          <td>{totals.netWeight.toFixed(1)}</td>
          <td>{totals.grossWeight.toFixed(1)}</td>
          <td>15CTN(S)</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
};

export default PackingTable;